import { createAsyncThunk } from '@reduxjs/toolkit';


import { BasicInfoApiPaths } from '../../Constant/ApiPaths/BasicInfoApiPaths';
import { BasicInfoHttpGetService } from '../../Services/BasicInfoHttpService';
import { IInquiryDiscountCode } from '../../Types/Queries/IInquiryDiscountCode';

export const inquiryDiscountCode = createAsyncThunk(
  'BasicInfo/inquiryDiscountCode',
  async (query: IInquiryDiscountCode) => {
    return await BasicInfoHttpGetService({
      url: `${BasicInfoApiPaths.DiscountCode.InquiryDiscountCode}`,
      params: query,
    });
  }
);
